import { parseBoardMarkers } from "../board/parse-board-markers";
import type { CurrentSessionMessage } from "./chat.api";
import type { ChatStoreMessage } from "./chat.store";

export const parseCurrentSessionMessages = (messages: readonly CurrentSessionMessage[]): ChatStoreMessage[] =>
  messages
    .filter((message): message is typeof message & { role: "user" | "assistant" } => message.role !== "system")
    .flatMap((message): ChatStoreMessage[] => {
      if (message.role === "user")
        return [{ role: message.role, content: message.content, createdAt: message.createdAt }];
      const parsed = parseBoardMarkers(message.content);
      const answer: ChatStoreMessage = {
        role: message.role,
        content: message.content,
        createdAt: message.createdAt,
        parts: message.parts?.length ? message.parts : undefined,
        segments: parsed.segments,
        warnings: parsed.warnings.length ? parsed.warnings : undefined,
        boards: parsed.boards.length ? parsed.boards : undefined,
      };
      return [answer];
    });
